/* global BRANCH_BASE_URL */

const NBA_TEAM_STATS_GET_THE_APP = `${BRANCH_BASE_URL}/nbateamstats`;
const NHL_TEAM_STATS_GET_THE_APP = `${BRANCH_BASE_URL}/nhlteamstats`;
const NFL_TEAM_STATS_GET_THE_APP = `${BRANCH_BASE_URL}/nflteamstats`;
const NCAAB_TEAM_STATS_GET_THE_APP = `${BRANCH_BASE_URL}/StWcbGRCUK`;
const MLB_TEAM_STATS_GET_THE_APP = `${BRANCH_BASE_URL}/pCnFyNncWK`;
const SOCCER_TEAM_STATS_GET_THE_APP = `${BRANCH_BASE_URL}/rx7XwKjdEM`;
const TODAYS_ALERTS = `${BRANCH_BASE_URL}/gettodaysalerts?campaign=FrictionCTA`;
const NCAAB_BRACKET_LINK = `${BRANCH_BASE_URL}/EM4NuLXQ7K`;
const BIXBY_LINK = `${BRANCH_BASE_URL}/9dr03GLP6K?campaign=Bixby`;
const BIXBY_EVENTS_LINK = `${BRANCH_BASE_URL}/bixbyscores`;
const BIXBY_TEAMS_LINK = `${BRANCH_BASE_URL}/bixbyteamnews`;
const BIXBY_EVENTS_CONTENT_LINK = `${BRANCH_BASE_URL}/eaWkPc3N5N`;
const BIXBY_TEAMS_CONTENT_LINK = `${BRANCH_BASE_URL}/inFoAS7N5N`;
const NEWS_ALERT_LINK = `${BRANCH_BASE_URL}/newsalert?campaign=`;

export const STATS_PAGE_LINKS = {
  nba: `${BRANCH_BASE_URL}/ObHe3mJCUK`,
  ncaab: `${BRANCH_BASE_URL}/ObHe3mJCUK`,
};

export default {
  nfl_team_stats_get_the_app: NFL_TEAM_STATS_GET_THE_APP,
  nhl_team_stats_get_the_app: NHL_TEAM_STATS_GET_THE_APP,
  nba_team_stats_get_the_app: NBA_TEAM_STATS_GET_THE_APP,
  ncaab_team_stats_get_the_app: NCAAB_TEAM_STATS_GET_THE_APP,
  mlb_team_stats_get_the_app: MLB_TEAM_STATS_GET_THE_APP,
  soccer_team_stats_get_the_app: SOCCER_TEAM_STATS_GET_THE_APP,
  stats_page_links: STATS_PAGE_LINKS,
  todays_alerts_base: TODAYS_ALERTS,
  ncaab_bracket_link: NCAAB_BRACKET_LINK,
  bixby_link: BIXBY_LINK,
  bixby_events_link: BIXBY_EVENTS_LINK,
  bixby_teams_link: BIXBY_TEAMS_LINK,
  bixby_events_content_link: BIXBY_EVENTS_CONTENT_LINK,
  bixby_teams_content_link: BIXBY_TEAMS_CONTENT_LINK,
  news_alert_link: NEWS_ALERT_LINK,
};
